/* Grid images Slider section 
--------------------------------------*/

// alert("hisss")
class FeaturedSlider {
  constructor (parent) {
    if (!parent) {
      return;
    }
    this.parent = parent;
    this.slider();
  }

  slider = () => {
    let sliders = qsa('.featured-slider-js');
    sliders?.forEach(element => {
      let featuredSliderSectionId = element.dataset.id;
      let featuredSliderSlide = element.dataset.slide;
      let featuredSliderClass = `.featured-slider-js.${featuredSliderSectionId}`;
      this.FeaturedSlider(featuredSliderClass,featuredSliderSlide);
    });
  }
  FeaturedSlider = (sliderClass,featuredSliderSlide) => {
    const recommendationSlider = new Swiper(sliderClass, {
      loop: true,
      // simulateTouch:false,
      slidesPerView: 4,
      slidesPerGroup: 1,
      shortSwipes: true,
      shortSwipesRatio: 0,
      autoHeight:true,
      speed: 1000,
      resistanceRatio:0.4,
      spaceBetween: 20,
      oopFillGroupWithBlank: false,
      breakpoints: {
        1: {
          slidesPerView: 2,
          spaceBetween: 10,
          pagination:false,
          autoHeight:false,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
          pagination:false,
          navigation:false,
        },
        1024: {
          slidesPerView: 4,
        },
      },

      // Navigation arrows
      navigation: {
        nextEl: `${sliderClass} ~ .swiper-button-next.featured-arrow`,
        prevEl: `${sliderClass} ~ .swiper-button-prev.featured-arrow`,
      },
      // Pagination dots
      pagination: {
        el: `${sliderClass} ~ .swiper-pagination.featured-pagination`,
        type: 'bullets',
        clickable : true
      },
    });
  }
}

new FeaturedSlider(qs('.featured-slider-js'));